import { PageHeading } from "../../shared/components/heading";
import request from "../../shared/utils/request";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader } from "../../shared/components/loader";
import { QuestionOptions } from "./questionOptions";
import { Feedback } from "./feedback";
import { LoadingButton } from "../../shared/components/loadingButton";
import { formatDate, formatTime } from "../../shared/utils/dateFormat";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Slide } from "react-awesome-reveal";

export const AnswerDetails = () => {
  const [loading, setLoading] = useState(false);
  const [grammerBookData, setGrammerBookData] = useState(null);
  const [activeTabValue, setActiveTabValue] = useState(0);
  const { id } = useParams();

  const tabDatas = ["Question Answer", "My Answer", "Answer Feedback"];

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await request.get(
        `student/getGrammerBookAnswerById/${id}`
      );
      if (response?.data?.status) {
        const data = response.data.data;
        setGrammerBookData(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const submitAnswer = async () => {
    const response = await request.post(`student/submitGrammerBookAnswer`, {
      answer_id: grammerBookData?.id,
    });
    if (response?.data?.success) {
      toast.success(response?.data?.message);
      fetchData();
    } else {
      toast.error("Failed to submit answer");
    }
  };

  return (
    <section id="services" className="services section my-library">
      <div className="container section-title" data-aos="fade-up">
        <Slide direction="down">
          <PageHeading heading="My Answer" />
        </Slide>
      </div>
      <Loader isLoading={loading} />
      <div className="container">
        <div className="preview-container">
          <div className="document-header">
            <h1 className="document-title">
              {grammerBookData?.grammerbook?.question}
            </h1>
            <p
              className="document-description"
              dangerouslySetInnerHTML={{
                __html: grammerBookData?.grammerbook?.question_description,
              }}
            ></p>
          </div>
          <div className="pdf-preview">
            <div className="mt-3">
              <div className="row">
                <div className="col-md-4">
                  {grammerBookData?.submitted_date && (
                    <span class="badge rounded-pill text-bg-success ">
                      Submitted On :{" "}
                      {formatDate(grammerBookData?.submitted_date)}{" "}
                      {formatTime(grammerBookData?.submitted_time)}
                    </span>
                  )}
                </div>
                <div className="col-md-4">
                  {grammerBookData?.evaluated_date && (
                    <span class="badge rounded-pill text-bg-success ">
                      Evaluated On :{" "}
                      {formatDate(grammerBookData?.evaluated_date)}
                    </span>
                  )}
                </div>
                <div className="col-md-4">
                  {!grammerBookData?.submit_status && (
                    <LoadingButton
                      isLoading={false}
                      buttonText={
                        grammerBookData?.submit_status
                          ? "Answer submitted for review"
                          : "Submit answer for review"
                      }
                      customClass={"create-btn float-end"}
                      disabled={grammerBookData?.submit_status}
                      onClick={() => {
                        submitAnswer();
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
            <ul class="nav nav-tabs mt-3">
              {tabDatas.map((tabData, index) => (
                <li
                  class="nav-item"
                  key={index}
                  onClick={() => {
                    setActiveTabValue(index);
                  }}
                >
                  <a
                    class={`nav-link ${
                      activeTabValue === index ? "active" : ""
                    }`}
                    aria-current="page"
                    href="javascript:;"
                  >
                    {tabData}
                  </a>
                </li>
              ))}
            </ul>
            {activeTabValue === 0 ? (
              <QuestionOptions
                answerOptions={grammerBookData?.grammerbook?.statement}
              />
            ) : activeTabValue === 1 ? (
              <QuestionOptions answerOptions={grammerBookData?.answer} />
            ) : (
              <Feedback feedback={grammerBookData?.feedback} />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
